


import React, { useEffect, useState } from "react";
import { IoArrowBack } from "react-icons/io5"; // Left Arrow Icon from react-icons
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const Applicant = () => {
  const { campaignId } = useParams();
  const [applicants, setApplicants] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate(); // For navigation

  useEffect(() => {
    const fetchApplicants = async () => {
      try {
        const response = await fetch(
          `https://server-side-influencer.onrender.com/brand/applicants/${campaignId}?page=${currentPage}&limit=${itemsPerPage}`
        );
        const data = await response.json();
        if (data.success) {
          setApplicants(data.data);
        } else {
          console.error("Failed to fetch applicants");
        }
      } catch (error) {
        console.error("Error fetching applicants:", error);
      }
    };
    fetchApplicants();
  }, [campaignId, currentPage]);

  const handleReject = async (applicantId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to undo this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, reject it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `https://server-side-influencer.onrender.com/brand/delete/${applicantId}`,
            { method: "DELETE" }
          );
          const data = await response.json();
          if (data.success) {
            Swal.fire("Rejected!", "The application has been rejected.", "success");
            setApplicants((prev) => prev.filter((applicant) => applicant._id !== applicantId));
          } else {
            Swal.fire("Error", "Failed to reject the applicant.", "error");
          }
        } catch (error) {
          Swal.fire("Error", "An error occurred while rejecting the applicant.", "error");
        }
      }
    });
  };

  const handleApproveClick = (applicant) => {
    setSelectedApplicant(applicant);
    setIsModalOpen(true);
  };

  const handleConfirmApprove = () => {
    setIsModalOpen(false);
    // Directly show success alert after approval
    Swal.fire("Approval Success", "The applicant has been approved successfully!", "success");
    console.log(`Applicant with ID ${selectedApplicant._id} approved.`);
  };

  // Get current applicants for the current page
  const indexOfLastApplicant = currentPage * itemsPerPage;
  const indexOfFirstApplicant = indexOfLastApplicant - itemsPerPage;
  const currentApplicants = applicants.slice(indexOfFirstApplicant, indexOfLastApplicant);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Pagination controls
  const totalPages = Math.ceil(applicants.length / itemsPerPage);

  return (
    <div className="flex h-screen mb-0 ">
      {/* Custom Header */}
      <div className="bg-gray-100 text-black flex items-center justify-between p-4 fixed w-full top-0 left-0 z-50">
        {/* Left Arrow Icon and Back Button */}
        <div onClick={() => navigate(-1)} className="cursor-pointer flex items-center">
          <IoArrowBack size={24} />
          <span className="ml-2">Back</span>
        </div>
        {/* Right Side Texts (can be dynamic or statics) */}
        <div className="text-right">Applicant</div>
      </div>

      {/* Main Content */}
      <div className="bg-white min-h-screen p-6 w-full mt-16" style={{ marginLeft: '1%' }}>
        <h1 className="text-3xl font-bold text-center mt-1 mb-6">Applicants for This Campaign</h1>

        {currentApplicants.length === 0 ? (
          <p className="text-center text-xl mt-10">No applicants for this campaign</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border-collapse shadow-lg rounded-lg">
              <thead>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="px-4 py-2">Profile Picture</th>
                  <th className="px-4 py-2">Name</th>
                  <th className="px-4 py-2">Age</th>
                  <th className="px-4 py-2">Followers</th>
                  <th className="px-4 py-2">Email</th>
                  <th className="px-4 py-2">Status</th>
                  <th className="px-4 py-2 whitespace-nowrap">Task Link</th>
                  <th className="px-4 py-2">Instagram</th>
                  <th className="px-4 py-2 whitespace-nowrap">approved budget</th>
                  <th className="px-4 py-2 whitespace-nowrap">Submitted Images</th>
                  <th className="px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentApplicants.map((applicant) => (
                  <tr key={applicant._id} className="border-b hover:bg-gray-100">
                    <td className="px-4 py-2">
                      <img src={applicant.profilePic} alt="Profile" className="w-12 h-12 rounded-full object-cover" />
                    </td>
                    <td className="px-4 py-2">{applicant.name}</td>
                    <td className="px-4 py-2">{applicant.age}</td>
                    <td className="px-4 py-2">{applicant.followers}</td>
                    <td className="px-4 py-2">
                      <a href={`mailto:${applicant.email}`} className="text-blue-500">{applicant.email}</a>
                    </td>
                    <td className="px-4 py-2">
                      <span className={`px-2 py-1 rounded-full text-white ${applicant.status === "selected" ? "bg-green-500" : "bg-red-500"}`}>
                        {applicant.status}
                      </span>
                    </td>
                    <td className="px-4 py-2">
                      <a href={applicant.taskLink} target="_blank" rel="noopener noreferrer" className="text-blue-500">Link</a>
                    </td>
                    <td className="px-4 py-2">
                      <a href={applicant.instagramLink} target="_blank" rel="noopener noreferrer" className="text-blue-500">Instagram</a>
                    </td>
                    <td className="px-4 py-2">
                      ₹{applicant.approvedBudget}
                    </td>

                    <td className="px-4 py-2">
                      {applicant.submittedImages && applicant.submittedImages.length > 0 && (
                        <div className="flex items-center space-x-2">
                          {applicant.submittedImages.map((image, index) => (
                            <a key={index} href={image} target="_blank" rel="noopener noreferrer">
                              <img src={image} alt={`submitted-${index}`} className="w-10 h-10 object-cover rounded-lg border border-gray-300" />
                            </a>
                          ))}
                        </div>
                      )}
                    </td>

                    <td className="px-4 py-2 text-center">
                      <div className="flex items-center justify-center">
                        <button
                          className="text-green-500 hover:text-green-700 mr-4"
                          onClick={() => handleApproveClick(applicant)}
                        >
                          Approve
                        </button>
                        <button
                          className="text-red-500 hover:text-red-700"
                          onClick={() => handleReject(applicant._id)}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="flex justify-center mt-4">
          <nav className="flex items-center space-x-2">
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                className={`px-3 py-1 rounded-lg ${index + 1 === currentPage ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-600"}`}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Modal for approving the applicantsss */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-2/3 sm:w-2/3 md:w-1/3 lg:w-2/4 xl:w-2/4">
            <h2 className="text-2xl font-bold mb-4">Confirm Approval</h2>
            <p>Are you sure you want to approve this applicant?</p>
            <div className="mt-4 flex justify-end">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-lg mr-2"
                onClick={handleConfirmApprove}
              >
                Approve
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-lg"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Applicant;
